import apiTools from '../api-tools/index'
import buildGetUserOrgTasks from './get-user-org-tasks'

const getUserOrgTasks = buildGetUserOrgTasks({
    apiTools
})

export default {
    getUserOrgTasks
}